"use strict";
// @flow
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapComponent = void 0;
var React = require("react");
var model_1 = require("../../../../model");
// TODO refactor this contstat to only constant file
var MapConstants_1 = require("./MapConstants");
var MapComponent = /** @class */ (function (_super) {
    __extends(MapComponent, _super);
    function MapComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.googleMarkers = []; // google.maps.marker;
        return _this;
    }
    MapComponent.prototype.clearLocations = function () {
        this.infoWindow = new google.maps.InfoWindow({});
        this.googleMarkers.forEach(function (marker) {
            // Google might be not defined at the first time
            google && google.maps.event.clearInstanceListeners(marker);
            marker.setMap(null);
        });
        this.googleMarkers = [];
    };
    // Fit Bounds, postpone if gmap is not ready, also postpone if tab is not active
    MapComponent.prototype.fitBounds = function (coords) {
        // Google is not defiend yet
        if (typeof google === 'undefined' || !this.gmap) {
            return;
        }
        // Fit on locations
        if (coords.length > 1) {
            var bounds_1 = new google.maps.LatLngBounds();
            coords.forEach(function (coord) {
                bounds_1.extend(new google.maps.LatLng(coord.latitude, coord.longitude));
            });
            this.gmap.fitBounds(bounds_1);
            // 1 location only case
        }
        else if (coords.length === 1) {
            var coord = coords[0];
            this.gmap.setCenter(new google.maps.LatLng(coord.latitude, coord.longitude));
        }
        else {
            this.defaultFitBounds();
        }
    };
    MapComponent.prototype.defaultFitBounds = function () {
        var _this = this;
        // Default center on Netherlands
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: MapConstants_1.DEFAULT_COUNTRY }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                _this.gmap.setCenter(results[0].geometry.location);
            }
        });
    };
    MapComponent.prototype.onChange = function (map) {
        this.gMapProps = map;
        this.setState({ zoom: map.zoom, center: map.center });
    };
    MapComponent.prototype.buildDefaultCircleIcon = function (options) {
        if (options === void 0) { options = {}; }
        return {
            path: google.maps.SymbolPath.CIRCLE,
            scale: options.scale || 8,
            anchor: undefined,
            fillColor: options.fillColor || MapConstants_1.COLORS.green,
            fillOpacity: options.fillOpacity || 1,
            strokeColor: options.strokeColor || MapConstants_1.COLORS.white,
            strokeWeight: options.strokeWeight || 1,
            strokeOpacity: options.strokeOpacity || 1,
        };
    };
    MapComponent.prototype.buildCluster = function (cluster, options) {
        if (options === void 0) { options = {}; }
        var marker = new google.maps.Marker({
            position: { lat: cluster.wy, lng: cluster.wx },
            zIndex: 10,
            label: {
                text: cluster.numPoints.toString(),
                color: 'white',
                fontSize: '8px',
            },
            map: this.gmap,
            icon: this.buildDefaultCircleIcon({ fillColor: options.fillColor || MapConstants_1.COLORS.blue }),
        });
        this.googleMarkers.push(marker);
    };
    MapComponent.prototype.buildAddressMarker = function (location, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var marker = new google.maps.Marker({
            position: { lat: location.coords.latitude, lng: location.coords.longitude },
            zIndex: 10,
            map: this.gmap,
            // If own icons is enable, set the icon, either fill it with default circle
            icon: (0, model_1.locationIcon)(location.type) || this.buildDefaultCircleIcon(),
        });
        var content = (0, model_1.getLocationInfoText)(location);
        if (content) {
            marker.addListener('click', function () {
                _this.infoWindow.setContent(content);
                _this.infoWindow.open(_this.gmap, marker);
            });
        }
        this.googleMarkers.push(marker);
    };
    return MapComponent;
}(React.Component));
exports.MapComponent = MapComponent;
